import {
  getByIdMediaSelector,
  getImageMediaIdByExerciseIdSelector,
  getVideoMediaIdByExerciseIdSelector,
  MEDIA_MODEL_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'

export const getExerciseMedia = (exerciseId) => (state) => {
  const mediaVideoId = getVideoMediaIdByExerciseIdSelector(exerciseId)(state)
  const mediaImageId = getImageMediaIdByExerciseIdSelector(exerciseId)(state)
  const mediaId = mediaImageId || mediaVideoId
  const media = getByIdMediaSelector(mediaId)(state)

  return {
    posterUrl: getValueReduxUtil(media, MEDIA_MODEL_KEY.THUMBNAIL),
    videoUrl: getValueReduxUtil(media, MEDIA_MODEL_KEY.URL)
  }
}
